// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchLeadReportAdmin } from "../../../state/reducers/adminReportSlice";
// import { Bar } from "react-chartjs-2";
// import "chart.js/auto";

// const LeadReportAdminChart = () => {
//   const dispatch = useDispatch();
//   const { data, status, error } = useSelector((state) => state.leadReportAdmin);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [generateClicked, setGenerateClicked] = useState(false);

//   const handleGenerate = () => {
//     if (startDate && endDate) {
//       const formatDate = (date) => {
//         const [year, month, day] = date.split("-");
//         return `${day}-${month}-${year}`; // Convert to DD-MM-YYYY
//       };
  
//       dispatch(
//         fetchLeadReportAdmin({
//           startDate: formatDate(startDate),
//           endDate: formatDate(endDate),
//         })
//       );
//       setGenerateClicked(true);
//     } else {
//       alert("Please provide both start and end dates");
//     }
//   };
  
//   const getChartData = () => {
//     if (status === "succeeded") {
//       const createdByIds = Object.keys(data); // IDs of creators
//       const createdCounts = createdByIds.map(
//         (id) => data[id].aggregated_data.total_created
//       );
//       const lostCounts = createdByIds.map(
//         (id) => data[id].aggregated_data.total_lost
//       );
//       const convertedCounts = createdByIds.map(
//         (id) => data[id].aggregated_data.total_converted
//       );

//       return {
//         labels: createdByIds,
//         datasets: [
//           {
//             label: "Total Created",
//             data: createdCounts,
//             backgroundColor: "#4caf50",
//           },
//           {
//             label: "Total Lost",
//             data: lostCounts,
//             backgroundColor: "#f44336",
//           },
//           {
//             label: "Total Converted",
//             data: convertedCounts,
//             backgroundColor: "#2196f3",
//           },
//         ],
//       };
//     }

//     return {
//       labels: [],
//       datasets: [
//         {
//           label: "No Data Available",
//           data: [],
//         },
//       ],
//     };
//   };

//   const renderList = () => {
//     if (generateClicked && status === "succeeded") {
//       return (
//         <div className="bg-white p-6 rounded-lg shadow-lg">
//           <h3 className="text-xl font-semibold mb-4">Lead Details</h3>
//           <table className="min-w-full">
//             <thead>
//               <tr>
//                 <th className="px-4 py-2 text-left">Created By ID</th>
//                 <th className="px-4 py-2 text-left">Total Created</th>
//                 <th className="px-4 py-2 text-left">Total Lost</th>
//                 <th className="px-4 py-2 text-left">Total Converted</th>
//               </tr>
//             </thead>
//             <tbody>
//               {Object.keys(data).map((id, index) => (
//                 <tr key={index}>
//                   <td className="px-4 py-2">{id}</td>
//                   <td className="px-4 py-2">
//                     {data[id].aggregated_data.total_created}
//                   </td>
//                   <td className="px-4 py-2">
//                     {data[id].aggregated_data.total_lost}
//                   </td>
//                   <td className="px-4 py-2">
//                     {data[id].aggregated_data.total_converted}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     }

//     return <div className="text-center text-gray-500">No data available</div>;
//   };

//   const chartData = getChartData();

//   return (
//     <div className="bg-white p-6 rounded-md shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-xl font-bold">Lead Report Admin</h1>
//       </div>
//       <div className="flex gap-4 mb-4">
//         <input
//           type="date"
//           value={startDate}
//           onChange={(e) => setStartDate(e.target.value)}
//           className="px-4 py-2 border rounded-md"
//         />
//         <input
//           type="date"
//           value={endDate}
//           onChange={(e) => setEndDate(e.target.value)}
//           className="px-4 py-2 border rounded-md"
//         />
//         <button
//           onClick={handleGenerate}
//           className="bg-blue-500 text-white px-4 py-2 rounded"
//         >
//           Generate
//         </button>
//       </div>

//       {status === "loading" && <p className="text-gray-500">Loading...</p>}
//       {status === "failed" && <p className="text-red-500">{error}</p>}

//       {generateClicked && status === "succeeded" ? (
//         <>
//           <Bar
//             data={chartData}
//             options={{
//               responsive: true,
//               plugins: {
//                 legend: { display: true },
//               },
//               scales: {
//                 y: {
//                   beginAtZero: true,
//                 },
//               },
//             }}
//           />
//           {renderList()}
//         </>
//       ) : (
//         <div className="text-center text-gray-500">No data to display</div>
//       )}
//     </div>
//   );
// };

// export default LeadReportAdminChart;


import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeadReportAdmin } from "../../../state/reducers/adminReportSlice";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

const LeadReportAdminChart = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.leadReportAdmin);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [generateClicked, setGenerateClicked] = useState(false);

  const handleGenerate = () => {
    if (startDate && endDate) {
      const formatDate = (date) => {
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`; // Convert to DD-MM-YYYY
      };

      dispatch(
        fetchLeadReportAdmin({
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
        })
      );
      setGenerateClicked(true);
    } else {
      alert("Please provide both start and end dates");
    }
  };

  const getChartData = () => {
    if (status === "succeeded") {
      // Get the names of creators based on the first lead in the grouped leads
      const createdByNames = Object.keys(data).map(
        (id) => data[id]?.leads[0]?.name || `User ${id}` // Use name if available, fallback to "User {id}"
      );
      const createdCounts = Object.keys(data).map(
        (id) => data[id].aggregated_data.total_created
      );
      const lostCounts = Object.keys(data).map(
        (id) => data[id].aggregated_data.total_lost
      );
      const convertedCounts = Object.keys(data).map(
        (id) => data[id].aggregated_data.total_converted
      );

      return {
        labels: createdByNames,
        datasets: [
          {
            label: "Total Created",
            data: createdCounts,
            backgroundColor: "#4caf50",
          },
          {
            label: "Total Lost",
            data: lostCounts,
            backgroundColor: "#f44336",
          },
          {
            label: "Total Converted",
            data: convertedCounts,
            backgroundColor: "#2196f3",
          },
        ],
      };
    }

    return {
      labels: [],
      datasets: [
        {
          label: "No Data Available",
          data: [],
        },
      ],
    };
  };

  const renderList = () => {
    if (generateClicked && status === "succeeded") {
      return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold mb-4">Lead Details</h3>
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left">Creator Name</th>
                <th className="px-4 py-2 text-left">Total Created</th>
                <th className="px-4 py-2 text-left">Total Lost</th>
                <th className="px-4 py-2 text-left">Total Converted</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data).map((id, index) => (
                <tr key={index}>
                  <td className="px-4 py-2">
                    {data[id]?.leads[0]?.name || `User ${id}`}
                  </td>
                  <td className="px-4 py-2">
                    {data[id].aggregated_data.total_created}
                  </td>
                  <td className="px-4 py-2">
                    {data[id].aggregated_data.total_lost}
                  </td>
                  <td className="px-4 py-2">
                    {data[id].aggregated_data.total_converted}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return <div className="text-center text-gray-500">No data available</div>;
  };

  const chartData = getChartData();

  return (
    <div className="bg-white p-6 rounded-md shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Lead Report Admin</h1>
      </div>
      <div className="flex gap-4 mb-4">
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="px-4 py-2 border rounded-md"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="px-4 py-2 border rounded-md"
        />
        <button
          onClick={handleGenerate}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Generate
        </button>
      </div>

      {status === "loading" && <p className="text-gray-500">Loading...</p>}
      {status === "failed" && <p className="text-red-500">{error}</p>}

      {generateClicked && status === "succeeded" ? (
        <>
          <Bar
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: { display: true },
              },
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            }}
          />
          {renderList()}
        </>
      ) : (
        <div className="text-center text-gray-500">No data to display</div>
      )}
    </div>
  );
};

export default LeadReportAdminChart;
